
import router from "@/router";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { computed, defineComponent, onMounted, ref, PropType } from "vue";
import { useStore } from "vuex";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { Field } from "vee-validate";
import { useRoute } from "vue-router";
import store from "@/store";

interface Filter {
  typeOfReview: string;
  title: string;
  appCode: string;
  appStatus: string;
  irbStatus: string;
  reviewer: string;
  piEmail: string;
}

export default defineComponent({
  name: "dropdown-irbchair-apps-filter",
  components: {},
  props: {
    tableCallFunction: String,
  },
  methods: {
    
  },
  setup(props) {
    const route = useRoute();
    let titleFromQuery = ref(route.query?.query);
    store.commit(Mutations.SET_IRB_APP_TITLE, titleFromQuery);
    const inputInformation = ref(titleFromQuery);
    
    const gotToSearchPage = function (data) {
      store.commit(Mutations.SET_IRB_APP_TITLE, data);
      router.push({ name: "search", query: {"query": data}});
    };

    const gotToSearchPageFromSubmmit = function (event) {
      store.commit(Mutations.SET_IRB_APP_TITLE, inputInformation.value);
      router.push({ name: "search", query: {"query": inputInformation.value}});
    };

    
    return {
      inputInformation,
      gotToSearchPage,
      gotToSearchPageFromSubmmit,
    };
  },
});
